import appReducer from "./AppReducer";
import appOfflineReducer from "./AppOfflineReducer";
import { createAppStore } from "jadro-pico-app/Redux/createAppStore";
import { StoreKeyEnum } from "jadro-pico-app/common/enums/StoreKeyEnum";

const { store, persistor } = createAppStore({
  key: StoreKeyEnum.PICO_COM,
  version: 1,
  reducers: { app: appReducer, appOffline: appOfflineReducer },
  whitelist: ["appOffline"],
});

export type RootState = ReturnType<typeof store.getState>;
export { persistor };
export default store;
